import React from "react";

export interface NavDrawerFooterProps {
  customerName?: string;
  accountLink?: string;
}

const NavDrawerFooter = ({
  customerName,
  accountLink,
}: NavDrawerFooterProps) => {
  const isSignedIn = customerName != "" && customerName != null;
  return (
    <div
      className={`sticky bottom-0 mt-auto flex w-full items-center bg-primary-50 px-12 py-7 ${
        isSignedIn ? "flex-col justify-center" : "justify-between"
      }`}
    >
      {isSignedIn ? (
        <>
          <p className="m-0 flex basis-6/12 items-center justify-center font-bold text-gray-700">
            Hi, {customerName}!
          </p>
          <hr className="mx-0 my-4 w-full border-primary-200" />
          <div className="flex w-full justify-between">
            {accountLink && <a href={accountLink}>My Account</a>}
            <a href="/account/logout">Sign Out</a>
          </div>
        </>
      ) : (
        <>
          <p className="m-0 font-bold text-gray-700">Welcome!</p>
          <a href="/account/login">Sign In</a>
        </>
      )}
    </div>
  );
};

export default NavDrawerFooter;
